import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";
import ClearYourDebtsFastWrapper from "@components/layouts/clearYourDebtsFastWrapper";
export default function ContactUsHome(): ReactElement {
    return (
        <ClearYourDebtsFastWrapper>
            <div className="bg-white">
                <ContactTop iconsFillColor={"#D0D1FF"} />
            </div>
            <FormSection iconsFillColor={"#FF823C"} />
        </ClearYourDebtsFastWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
